import React from 'react';
import clsx from 'clsx';
import {
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	makeStyles,
} from '@material-ui/core';
import ApplicationActionButtons from './ApplicationActionButtons';
import { formatSubmittedDate, formatLastEditedDate } from '../utils/applicationUtils';

const TABLE_HEADERS = ['Position', 'Company', 'Position Location', 'Date Submitted', 'Last Edited Date', ''];

const useStyles = makeStyles(theme => ({
	paper: {
		width: '90%',
		boxShadow: 'none',
		[theme.breakpoints.down('sm')]: {
			width: '100%',
		},
	},
	desktopOnly: {
		[theme.breakpoints.down('sm')]: {
			display: 'none',
		},
	},
	tableBorder: {
		border: '1px solid #ddd',
	},
	tableContainer: {
		maxHeight: theme.spacing(50),
		position: 'sticky',
	},
	buttonSection: {
		display: 'flex',
		gap: '8px',
	},
}));

const DesktopApplicationTable = ({ applications, onView, onEdit, onContinue }) => {
	const classes = useStyles();

	return (
		<Paper className={clsx(classes.paper, classes.desktopOnly)}>
			<TableContainer className={classes.tableContainer}>
				<Table stickyHeader aria-label="sticky table">
					<TableHead>
						<TableRow>
							{TABLE_HEADERS.map(header => (
								<TableCell key={header} className={classes.tableBorder}>
									{header}
								</TableCell>
							))}
						</TableRow>
					</TableHead>
					<TableBody>
						{applications.map((application, index) => (
							<TableRow key={`${application?.jobOpeningGuid}-${index}`}>
								<TableCell className={classes.tableBorder}>{application?.positionTitle}</TableCell>
								<TableCell className={classes.tableBorder}>{application?.companyName}</TableCell>
								<TableCell className={classes.tableBorder}>
									{[application?.positionCity, application?.positionState].filter(v => v).join(', ')}
								</TableCell>
								<TableCell className={classes.tableBorder}>
									{formatSubmittedDate(application?.submittedDate)}
								</TableCell>
								<TableCell className={classes.tableBorder}>
									{formatLastEditedDate(application?.lastEditedDate, application?.submittedDate)}
								</TableCell>
								<TableCell className={classes.tableBorder}>
									<div className={classes.buttonSection}>
										<ApplicationActionButtons
											application={application}
											onView={onView}
											onEdit={onEdit}
											onContinue={onContinue}

										/>
									</div>
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</TableContainer>
		</Paper>
	);
};

export default DesktopApplicationTable;